// extracted by mini-css-extract-plugin
export default {"wrap":"credits_wrap__3fjo4","list":"credits_list__Sj3Lo","empty":"credits_empty__9Xeo4"};